// extracted by mini-css-extract-plugin
module.exports = {"badge":"ParticipationBadge_badge__5F1pj","badge__name":"ParticipationBadge_badge__name__LiuJO"};